import { api } from "../base";
import { riskEndpoints } from "./risk";
import type { IUpdateCustomerCreditLimitRequest } from "@pulse-ui/codegen-v2/generated_ts/venues/talos";
import type { IPulseApiResponse } from "@pulse-ui/codegen-v2/generated_ts/api";

export type { IUpdateCustomerCreditLimitRequest } from "@pulse-ui/codegen-v2/generated_ts/venues/talos";
export type { IPulseApiResponse } from "@pulse-ui/codegen-v2/generated_ts/api";

const customerCreditLimitEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    updateCustomerCreditLimit: build.mutation<
      IPulseApiResponse,
      IUpdateCustomerCreditLimitRequest
    >({
      query: (body) => ({
        url: "/api/trading-ops/v1/customer-credit-limits",
        method: "POST",
        body,
      }),
      // Talos -> risk-checks stream -> server cache propagation can outrun
      // an immediate refetch, so patch the cache for instant feedback and
      // let the 5s `getRiskExposure` poll reconcile once Talos catches up.
      async onQueryStarted({ counterparty, quantity }, { dispatch, queryFulfilled }) {
        const patch = dispatch(
          riskEndpoints.util.updateQueryData(
            "getRiskExposure",
            undefined,
            (draft) => {
              for (const view of [draft.low, draft.high]) {
                const target = view.counterparties.find(
                  (cp) => cp.counterparty === counterparty,
                );
                if (target) target.exposure_limit = quantity;
              }
            },
          ),
        );
        try {
          const { data } = await queryFulfilled;
          if (!data.success) patch.undo();
        } catch {
          patch.undo();
        }
      },
    }),
  }),
});

export const {
  useUpdateCustomerCreditLimitMutation,
} = customerCreditLimitEndpoints;
